import type { ReportHubCategoryId } from '../types/constants'

export const LIBERTY_ORG_ID = 1

/**
 * Column stacks:
 * Financial | Property + Performance | Reimbursements + Communication
 */
export const HUB_COLUMN_ORDER: ReportHubCategoryId[][] = [
  ['financial-payments'],
  ['property-applications', 'performance-growth'],
  ['reimbursements', 'communication'],
]
